export const getRoomCountText = (rooms) => {
	const types = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 };
	rooms.forEach((room) => {
		types[room.type] += 1;
	});
	const halls = [];
	if (types[1]) {
		halls.push(
			t('{n} помещение|{n} помещения|{n} помещений', { n: types[1] }),
		);
	}
	if (types[2]) {
		halls.push(
			t(
				'{n} открытая площадка|{n} открытых площадки|{n} открытых площадок',
				{ n: types[2] },
			),
		);
	}
	if (types[3]) {
		halls.push(
			t(
				'{n} помещение + открытая площадка|{n} помещения + открытых площадки|{n} помещений + открытых площадок',
				{ n: types[3] },
			),
		);
	}
	if (types[4]) {
		halls.push(t('{n} терраса|{n} террасы|{n} террас', { n: types[4] }));
	}
	if (types[5]) {
		halls.push(
			t('{n} терраса на крыше|{n} террасы на крыше|{n} террас на крыше', {
				n: types[5],
			}),
		);
	}
	if (types[6]) {
		halls.push(
			t(
				'{n} открытая площадка с бассейном|{n} открытых площадки с бассейном|{n} открытых площадок с бассейном',
				{ n: types[6] },
			),
		);
	}

	if (halls.length > 1) {
		const lawns = halls.pop();
		return t('{halls} и {lawns}', {
			halls: halls.join(', '),
			lawns,
		});
	}

	return halls.pop();
};

export default { getRoomCountText };
